import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

export enum IconType {
  // nove ikonky pre zlatu priadku
  phone = 'phone',
  email = 'email',
  facebook = 'facebook',
  favourite = 'favourite',
  logoSymbol = 'logoSymbol',
  ball = 'ball',
  heart = 'heart',
  calendar = 'calendar',
  listMenu = 'listMenu',
  listMenuMobile = 'listMenuMobile',
  search = 'search',
  account = 'account',
  upArrow = 'upArrow',
  rightArrow = 'rightArrow',
  leftArrow = 'leftArrow',
  downArrow = 'downArrow',
  gallery = 'gallery',
  check = 'check',
  x = 'x',
  cart = 'cart',
  chevronRight = 'chevronRight',
  chevronRightSmall = 'chevronRightSmall',
  chevronLeft = 'chevronLeft',
  chevronLeftSmall = 'chevronLeftSmall',
  xSmall = 'xSmall',
  symbol_1 = 'symbol_1',
  symbol_2 = 'symbol_2',
  symbol_3 = 'symbol_3',
  symbol_4 = 'symbol_4',
  symbol_5 = 'symbol_5',
  symbol_6 = 'symbol_6',
  symbol_7 = 'symbol_7',
  symbol_8 = 'symbol_8',
  symbol_9 = 'symbol_9',
  symbol_10 = 'symbol_10',
  symbol_11 = 'symbol_11',
  symbol_12 = 'symbol_12',
  symbol_13 = 'symbol_13',
  symbol_14 = 'symbol_14',
  symbol_15 = 'symbol_15',
  symbol_16 = 'symbol_16',
  symbol_17 = 'symbol_17',
  cardView = 'cardView',
  filter = 'filter',
  chevronDownSmall = 'chevronDownSmall',
  chevronUpSmall = 'chevronUpSmall',
  close = 'close',
  emptyCart = 'emptyCart',
  newAddress = 'newAddress',
  sale = 'sale',
  gift = 'gift',
  // stare ikonky zo sanitasu
  listView = 'listView',
  user = 'user',
  back = 'back',
  upload = 'upload',
  success = 'success',
  error = 'error',
  document = 'document',
  refresh = 'refresh',
  paid = 'paid',
  time = 'time',
  inwork = 'inwork',
  checked = 'checked',
  trash = 'trash',
  minus = 'minus',
  plus = 'plus',
  cartDone = 'cartDone',
  finishedOrder = 'finishedOrder',
  filterBottomArrow = 'filterBottomArrow',
  backFilter = 'backFilter',
  resetFilter = 'resetFilter',
  home = 'home',
  person = 'person',
  desc = 'desc',
  instructions = 'instructions',
  healing = 'healing',
  star = 'star',
  category = 'category',
  cartLarge = 'cartLarge',
  download = 'download',
  scroll = 'scroll',
  freeDel = 'freeDel',
  login = 'login',
}

interface Props {
  icon: IconType;
  className?: string;
  viewBox?: string;
  fill?: string;
  title?: string;
  alt?: string;
  cursor?: string;
  marginLeft?: number;
  marginRight?: number;
  height?: number;
  width?: number;
  onClick?: any;
  rotate?: number;
}

const icons = {
  // nove ikonky pre zlatu priadku
  sale: () => (
    <path
      d="M20,40C9,40,0,31,0,20C0,9,9,0,20,0c11,0,20,9,20,20C40,31,31,40,20,40z M20,1.5C9.8,1.5,1.5,9.8,1.5,20
      S9.8,38.5,20,38.5S38.5,30.2,38.5,20S30.2,1.5,20,1.5z M14.4,26.7l12.2-12.2c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0L13.3,25.6
      c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2S14.3,26.8,14.4,26.7z M15.2,18.1c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9
      s2.9,1.3,2.9,2.9S16.8,18.1,15.2,18.1z M15.2,13.8c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S16,13.8,15.2,13.8z
      M24.8,27.8c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9S26.4,27.8,24.8,27.8z M24.8,23.4c-0.8,0-1.4,0.6-1.4,1.4
      s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S25.6,23.4,24.8,23.4z"
    />
  ),
  gift: () => (
    <path
      d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M20,38.5C9.8,38.5,1.5,30.2,1.5,20
      S9.8,1.5,20,1.5S38.5,9.8,38.5,20S30.2,38.5,20,38.5z M28,15.2h-2c0.2-0.4,0.3-0.8,0.3-1.2c0-1.5-1.2-2.8-2.8-2.8
      c-1.9,0-3,1.3-3.6,2.6c-0.6-1.2-1.7-2.6-3.6-2.6c-1.5,0-2.8,1.2-2.8,2.8c0,0.5,0.1,0.9,0.3,1.2h-2c-0.4,0-0.8,0.3-0.8,0.8v4
      c0,0.4,0.3,0.8,0.8,0.8h0.9V28c0,0.4,0.3,0.8,0.8,0.8h12.8c0.4,0,0.8-0.3,0.8-0.8v-7.2H28c0.4,0,0.8-0.3,0.8-0.8v-4
      C28.8,15.6,28.4,15.2,28,15.2z M23.6,12.8c0.7,0,1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2H21C21.4,14.2,22.2,12.8,23.6,12.8z M15.1,14
      c0-0.7,0.6-1.2,1.2-1.2c1.4,0,2.2,1.5,2.6,2.5h-2.6C15.7,15.2,15.1,14.7,15.1,14z M12.8,16.8h3.6h2.9v2.5h-6.5V16.8z M14.4,20.8h4.9
      v6.5h-4.9V20.8z M25.7,27.2h-4.9v-6.5h4.9V27.2z M27.2,19.2h-6.5v-2.5h2.8h3.7V19.2z"
    />
  ),
  emptyCart: () => (
    <path
      d="M31.7,65c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3s5.3-2.4,5.3-5.3S34.6,65,31.7,65z M31.7,71.7
      c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S32.4,71.7,31.7,71.7z M58.3,65c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3
      s5.3-2.4,5.3-5.3S61.3,65,58.3,65z M58.3,71.7c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S59.1,71.7,58.3,71.7z
       M74.9,22.1c-0.4-0.5-0.9-0.7-1.5-0.7h-55l-3-15.1c-0.2-0.9-1-1.6-2-1.6H6.7c-1.1,0-2,0.9-2,2s0.9,2,2,2h5l3,15c0,0.1,0,0.1,0,0.2
      l5.6,27.9c0.8,4.1,4.4,7,8.5,7c0.1,0,0.1,0,0.2,0h32.4c0.1,0,0.1,0,0.2,0c4.1,0,7.7-2.9,8.5-7l5.3-28C75.4,23.1,75.3,22.5,74.9,22.1
      z M66,50.9c-0.4,2.2-2.4,3.8-4.7,3.8H28.9c-2.3,0.1-4.2-1.5-4.7-3.8l-5.1-25.6h51.8L66,50.9z M37,36c0-1.7,1.3-3,3-3s3,1.3,3,3
      s-1.3,3-3,3S37,37.7,37,36z M47,36c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3S47,37.7,47,36z M38.1,44.8c2-1.6,4.5-2.4,7-2.3
      c2.5-0.1,4.9,0.8,6.9,2.3c0.7,0.5,0.8,1.5,0.3,2.1c-0.3,0.4-0.7,0.6-1.2,0.6c-0.3,0-0.7-0.1-0.9-0.3c-1.4-1.1-3.2-1.7-5-1.7
      c-1.9-0.1-3.7,0.6-5.1,1.7c-0.7,0.5-1.6,0.4-2.1-0.3C37.3,46.3,37.4,45.3,38.1,44.8z"
    />
  ),
  symbol_1: () => (
    <path
      d="M31.3,4c-0.5-0.1-1.1,0.3-1.2,0.8l-0.6,3.5c-0.6-0.3-1.3-0.5-2.2-0.5C25.5,7.8,24,9,24,9.1c0,0-0.1,0.1-0.3,0.2
      c-0.3-3.9-3.5-6.9-7.5-6.9c-3.9,0-7.2,3-7.5,6.9C8.5,9.1,8.4,9.1,8.4,9.1C8.3,9,6.8,7.8,5,7.8c-0.8,0-1.6,0.2-2.2,0.5L2.1,4.8
      C2,4.3,1.5,3.9,1,4C0.4,4.1,0.1,4.6,0.2,5.2l3.3,18.4C4,26.1,6,28,8.4,28h15.6c2.4,0,4.4-1.9,4.9-4.5l3.3-18.4
      C32.2,4.6,31.9,4.1,31.3,4z M10.1,9.8c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6.1V19c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6v-5.1
      c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v7.8c0,0.3-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6v-7.8c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8
      v8.7c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6v-8.7c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v6.9c0,0.3-0.3,0.6-0.6,0.6
      s-0.6-0.3-0.6-0.6v-9.1c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v3.9c0,0.7-0.5,1.4-1.2,1.5V9.8z M26.9,23.2
      c-0.3,1.6-1.5,2.8-2.9,2.8H8.4c-1.4,0-2.6-1.2-2.9-2.8L3.2,10.4C3.5,10.1,4.2,9.8,5,9.8c1.2,0,2.2,0.8,2.2,0.8
      c0.1,0.1,0.7,0.5,1.5,0.8v6.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.2,1.6-0.4v2.5c0,1.2,0.9,2.1,2.1,2.1c0.2,0,0.4,0,0.6-0.1
      c0.1,1.1,1,1.9,2.1,1.9c0.8,0,1.5-0.4,1.8-1.1c0.3,0.1,0.6,0.2,0.9,0.2c1.2,0,2.1-0.9,2.1-2.1V21c0.2,0.1,0.4,0.1,0.6,0.1
      c1.2,0,2.1-0.9,2.1-2.1v-7.5c0.9-0.3,1.5-0.8,1.5-0.8c0,0,1-0.8,2.2-0.8c0.7,0,1.4,0.3,1.8,0.5L26.9,23.2z"
    />
  ),
  symbol_2: () => (
    <path
      d="M31.3,4c-0.5-0.1-1.1,0.3-1.2,0.8l-0.6,3.5c-0.7-0.3-1.4-0.5-2.2-0.5c-1.2,0-2.4,0.5-3.4,1.2
      c-0.6,0.5-1.4,0.8-2.1,0.8c-0.8,0-1.6-0.3-2.2-0.8c-0.1,0-0.1-0.1-0.2-0.1c-0.9-0.7-2.1-1-3.3-1.1c-1.2,0.1-2.4,0.5-3.3,1.2
      c-0.7,0.5-1.4,0.8-2.2,0.8C9.8,9.8,9,9.5,8.4,9c-1-0.7-2.1-1.2-3.4-1.2C4.2,7.9,3.5,8,2.8,8.3L2.1,4.8C2,4.3,1.5,3.9,1,4
      C0.4,4.1,0.1,4.6,0.2,5.2l3.3,18.3C3.8,26,5.8,27.9,8.4,28L24,28c2.5-0.1,4.5-2,4.8-4.5l3.3-18.4C32.2,4.6,31.9,4.1,31.3,4z
      M26.8,23.2c-0.2,1.5-1.4,2.7-2.9,2.8L8.4,26c-1.5-0.1-2.8-1.2-3-2.8L3.2,10.4c0.6-0.3,1.2-0.5,1.8-0.6c0.8,0,1.6,0.3,2.2,0.8
      c1,0.7,2.1,1.1,3.4,1.2c1.2-0.1,2.4-0.5,3.4-1.2c0.6-0.5,1.4-0.8,2.1-0.8c0.8,0,1.6,0.3,2.2,0.8c0.1,0,0.1,0.1,0.2,0.1
      c0.9,0.7,2.1,1,3.3,1.1c1.2-0.1,2.4-0.5,3.3-1.2c0.7-0.5,1.4-0.8,2.2-0.8c0.7,0,1.3,0.2,1.8,0.6L26.8,23.2z M15.1,18.3
      c0.4,0.4,0.7,1,0.6,1.6c0,0.7-0.3,1.4-0.7,1.9c-0.6,0.6-1.4,0.9-2.2,0.8c-1,0.1-2-0.3-2.5-1.2C10,21,9.8,20.4,9.8,19.8h1.6
      c0,0.3,0,0.6,0.2,0.8c0.2,0.4,0.6,0.7,1.1,0.6c0.3,0,0.6-0.1,0.9-0.3c0.3-0.3,0.4-0.6,0.4-1c0-0.5-0.2-0.9-0.7-1.1
      c-0.4-0.1-0.8-0.2-1.2-0.2v-1.2c0.4,0,0.8,0,1.1-0.2c0.4-0.2,0.6-0.6,0.6-1c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3
      c-0.3,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.6-0.3,1H10c0-0.4,0.1-0.8,0.2-1.2c0.1-0.3,0.4-0.7,0.7-0.9c0.2-0.2,0.5-0.4,0.8-0.5
      c0.4-0.1,0.7-0.2,1.1-0.2c0.7,0,1.4,0.2,2,0.6c0.5,0.4,0.8,1,0.8,1.7c0,0.5-0.1,0.9-0.5,1.3c-0.2,0.2-0.4,0.3-0.6,0.4
      C14.7,18,14.9,18.1,15.1,18.3z M19.4,13.9c-0.9-0.1-1.8,0.4-2.3,1.1c-0.5,1-0.7,2.1-0.6,3.3c-0.1,1.1,0.2,2.2,0.6,3.2
      c0.5,0.8,1.4,1.2,2.3,1.1c0.9,0.1,1.8-0.3,2.3-1.1c0.5-1,0.7-2.1,0.7-3.2c0.1-1.1-0.2-2.2-0.7-3.2C21.3,14.2,20.4,13.8,19.4,13.9z
      M20.5,20.5c-0.1,0.4-0.4,0.7-0.7,0.7c-0.6,0.1-1.1-0.2-1.3-0.7v0c-0.2-0.7-0.3-1.5-0.3-2.2c0-0.8,0.1-1.5,0.2-2.3
      c0.1-0.4,0.5-0.7,1-0.7c0.5,0,0.9,0.3,1,0.7c0.2,0.7,0.3,1.5,0.3,2.2C20.7,19,20.7,19.8,20.5,20.5z"
    />
  ),
  symbol_3: () => (
    <path
      d="M31.3,3.4c-0.5-0.1-1.1,0.3-1.2,0.8l-0.6,3.5c-0.7-0.3-1.4-0.5-2.2-0.5c-1.2,0-2.4,0.5-3.4,1.2
      c-0.6,0.5-1.4,0.8-2.1,0.8c-0.8,0-1.6-0.3-2.2-0.8c-0.1,0-0.1-0.1-0.2-0.1c-0.9-0.7-2.1-1-3.3-1.1c-1.2,0.1-2.4,0.5-3.3,1.2
      c-0.7,0.5-1.4,0.8-2.2,0.8C9.8,9.2,9,8.9,8.4,8.4c-1-0.7-2.1-1.1-3.4-1.2c-0.7,0-1.5,0.2-2.1,0.5L2.1,4.2C2,3.7,1.5,3.3,1,3.4
      C0.4,3.5,0.1,4,0.2,4.6l3.3,18.3c0.3,2.5,2.3,4.4,4.9,4.5l15.6,0c2.5-0.1,4.5-2,4.8-4.5l3.3-18.4C32.2,4,31.9,3.5,31.3,3.4z
        M26.8,22.6c-0.2,1.5-1.4,2.7-2.9,2.8l-15.5,0c-1.5-0.1-2.8-1.2-3-2.8L3.2,9.8c0.6-0.3,1.2-0.5,1.8-0.6c0.8,0,1.6,0.3,2.2,0.8
      c1,0.7,2.1,1.1,3.4,1.2c1.2,0,2.4-0.5,3.4-1.2c0.6-0.5,1.4-0.8,2.1-0.8c0.8,0,1.6,0.3,2.2,0.8c0.1,0,0.1,0.1,0.2,0.1
      c0.9,0.7,2.1,1,3.3,1.1c1.2-0.1,2.4-0.5,3.3-1.2c0.7-0.5,1.4-0.8,2.2-0.8c0.7,0,1.3,0.2,1.8,0.6L26.8,22.6z M14.8,13.4h-1.9
      l-3.1,5.1V20h3.4v1.8h1.6V20h1l0-1.3h-1V13.4z M13.2,18.7h-2.1l2.1-3.7V18.7z M19.4,13.3c-0.9-0.1-1.8,0.4-2.3,1.1
      c-0.5,1-0.7,2.1-0.6,3.2c-0.1,1.1,0.2,2.2,0.6,3.2c0.5,0.8,1.4,1.2,2.3,1.1c0.9,0.1,1.8-0.3,2.3-1.1c0.5-1,0.7-2.1,0.7-3.2
      c0.1-1.1-0.2-2.2-0.7-3.2C21.3,13.6,20.4,13.2,19.4,13.3z M20.5,19.9c-0.1,0.4-0.4,0.6-0.7,0.7c-0.6,0.1-1.1-0.2-1.3-0.7
      c-0.2-0.7-0.3-1.5-0.2-2.2c0-0.8,0-1.5,0.2-2.3c0.1-0.4,0.5-0.8,1-0.7c0.5,0,0.9,0.3,1,0.7c0.2,0.7,0.3,1.5,0.2,2.3
      C20.7,18.4,20.7,19.2,20.5,19.9z"
    />
  ),
  symbol_4: () => (
    <path
      d="M31.3,3.4c-0.5-0.1-1.1,0.3-1.2,0.8l-0.6,3.5c-0.7-0.3-1.4-0.5-2.2-0.5c-1.2,0-2.4,0.5-3.4,1.2
      c-0.6,0.5-1.4,0.8-2.1,0.8c-0.8,0-1.6-0.3-2.2-0.8c-0.1,0-0.1-0.1-0.2-0.1c-0.9-0.7-2.1-1-3.3-1.1c-1.2,0.1-2.4,0.5-3.3,1.2
      c-0.7,0.5-1.4,0.8-2.2,0.8C9.8,9.2,9,8.9,8.4,8.4c-1-0.7-2.1-1.1-3.4-1.2c-0.7,0-1.5,0.2-2.1,0.5L2.1,4.2C2,3.7,1.5,3.3,1,3.4
      C0.4,3.5,0.1,4,0.2,4.6l3.3,18.3c0.3,2.5,2.3,4.4,4.9,4.5l15.6,0c2.5-0.1,4.5-2,4.8-4.5l3.3-18.4C32.2,4,31.9,3.5,31.3,3.4z
       M26.8,22.6c-0.2,1.5-1.4,2.7-2.9,2.8l-15.5,0c-1.5-0.1-2.8-1.2-3-2.8L3.2,9.8c0.6-0.3,1.2-0.5,1.8-0.6c0.8,0,1.6,0.3,2.2,0.8
      c1,0.7,2.1,1.1,3.4,1.2c1.2,0,2.4-0.5,3.4-1.2c0.6-0.5,1.4-0.8,2.1-0.8c0.8,0,1.6,0.3,2.2,0.8c0.1,0,0.1,0.1,0.2,0.1
      c0.9,0.7,2.1,1,3.3,1.1c1.2-0.1,2.4-0.5,3.3-1.2c0.7-0.5,1.4-0.8,2.2-0.8c0.7,0,1.3,0.2,1.8,0.6L26.8,22.6z M13.2,16.3
      c-0.3,0-0.6,0-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5c0-0.5,0.1-1,0.2-1.5c0.1-0.5,0.6-0.9,1.2-0.9c0.3,0,0.6,0.1,0.8,0.4
      c0.1,0.1,0.1,0.3,0.2,0.4l1.7,0c0-0.6-0.3-1.2-0.8-1.6c-0.5-0.4-1.2-0.6-1.9-0.6c-0.5,0-1,0.1-1.4,0.4c-0.4,0.2-0.8,0.6-1,1
      c-0.3,0.6-0.5,1.2-0.6,1.8c-0.1,0.5-0.1,1.1-0.1,1.6c0,0.9,0.2,1.9,0.6,2.7c0.5,0.9,1.4,1.4,2.4,1.3c0.8,0.1,1.7-0.3,2.2-0.9
      c0.5-0.6,0.7-1.3,0.7-2.1c0-0.7-0.2-1.5-0.7-2C14.5,16.5,13.9,16.3,13.2,16.3z M13.7,20.3c-0.2,0.3-0.5,0.4-0.9,0.4
      c-0.4,0-0.7-0.2-0.9-0.4h0c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.5,0.1-0.9,0.5-1.2c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.7,0.1,0.9,0.4
      c0.3,0.3,0.4,0.7,0.4,1.1C14,19.6,13.9,20,13.7,20.3z M19.4,13.3c-0.9-0.1-1.8,0.4-2.3,1.1c-0.5,1-0.7,2.1-0.6,3.2
      c-0.1,1.1,0.2,2.2,0.6,3.2c0.5,0.8,1.4,1.2,2.3,1.1c0.9,0.1,1.8-0.3,2.3-1.1c0.5-1,0.7-2.1,0.7-3.2c0.1-1.1-0.2-2.2-0.7-3.2
      C21.3,13.6,20.4,13.2,19.4,13.3z M20.5,19.9c-0.1,0.4-0.4,0.6-0.7,0.7c-0.6,0.1-1.1-0.2-1.3-0.7c-0.2-0.7-0.3-1.5-0.2-2.2
      c0-0.8,0-1.5,0.2-2.3c0.1-0.4,0.5-0.8,1-0.7c0.5,0,0.9,0.3,1,0.7c0.2,0.7,0.3,1.5,0.2,2.3C20.7,18.4,20.7,19.2,20.5,19.9z"
    />
  ),
  symbol_5: () => (
    <path
      d="M31.3,3.4c-0.5-0.1-1.1,0.3-1.2,0.8l-0.6,3.5c-0.7-0.3-1.4-0.5-2.2-0.5c-1.2,0-2.4,0.5-3.4,1.2
    c-0.6,0.5-1.4,0.8-2.1,0.8c-0.8,0-1.6-0.3-2.2-0.8c-0.1,0-0.1-0.1-0.2-0.1c-0.9-0.7-2.1-1-3.3-1.1c-1.2,0.1-2.4,0.5-3.3,1.2
    c-0.7,0.5-1.4,0.8-2.2,0.8C9.8,9.2,9,8.9,8.4,8.4c-1-0.7-2.1-1.1-3.4-1.2c-0.7,0-1.5,0.2-2.1,0.5L2.1,4.2C2,3.7,1.5,3.3,1,3.4
    C0.4,3.5,0.1,4,0.2,4.6l3.3,18.3c0.3,2.5,2.3,4.4,4.9,4.5l15.6,0c2.5-0.1,4.5-2,4.8-4.5l3.3-18.4C32.2,4,31.9,3.5,31.3,3.4z
     M26.8,22.6c-0.2,1.5-1.4,2.7-2.9,2.8l-15.5,0c-1.5-0.1-2.8-1.2-3-2.8L3.2,9.8c0.6-0.3,1.2-0.5,1.8-0.6c0.8,0,1.6,0.3,2.2,0.8
    c1,0.7,2.1,1.1,3.4,1.2c1.2,0,2.4-0.5,3.4-1.2c0.6-0.5,1.4-0.8,2.1-0.8c0.8,0,1.6,0.3,2.2,0.8c0.1,0,0.1,0.1,0.2,0.1
    c0.9,0.7,2.1,1,3.3,1.1c1.2-0.1,2.4-0.5,3.3-1.2c0.7-0.5,1.4-0.8,2.2-0.8c0.7,0,1.3,0.2,1.8,0.6L26.8,22.6z M12.6,13.3
    c-0.8,0-1.5,0.3-2,0.8c-0.6,0.6-0.8,1.4-0.8,2.3c0,0.8,0.2,1.5,0.8,2c0.5,0.5,1.1,0.7,1.8,0.7c0.4,0,0.8-0.1,1.1-0.3
    c0.2-0.1,0.4-0.3,0.5-0.4c0,0.5-0.1,1-0.2,1.5c-0.1,0.5-0.6,0.9-1.2,0.9c-0.5,0-0.9-0.3-1-0.9H10c0,0.7,0.4,1.3,0.9,1.7
    c0.5,0.4,1.1,0.6,1.7,0.6c1.3,0,2.4-0.8,2.8-2c0.3-0.8,0.4-1.7,0.4-2.6c0-0.9-0.1-1.7-0.4-2.6C14.9,13.9,13.8,13.2,12.6,13.3z
     M13.4,17.5c-0.5,0.3-1.2,0.2-1.6-0.2c-0.2-0.3-0.3-0.7-0.3-1.1c-0.1-0.5,0.1-0.9,0.5-1.3c0.2-0.2,0.5-0.2,0.7-0.2
    c0.4,0,0.7,0.1,0.9,0.4c0.2,0.3,0.4,0.7,0.3,1.1C14.1,16.7,13.8,17.2,13.4,17.5z M21.6,17c0.5,0.5,0.8,1.3,0.8,2
    c0,0.8-0.3,1.5-0.8,2.1c-0.6,0.6-1.4,1-2.3,0.9c-0.7,0-1.4-0.2-2-0.7c-0.5-0.5-0.8-1.1-0.9-1.8l1.7,0c0,0.3,0.2,0.6,0.4,0.8
    c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,0.9-0.4c0.2-0.3,0.3-0.7,0.3-1.1c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.6-0.5-0.9-0.5
    c-0.2,0-0.4,0-0.5,0.1c-0.3,0.1-0.5,0.3-0.6,0.5l-1.5-0.1l0.6-4.7H22v1.4h-3.5l-0.3,1.9c0.2-0.1,0.4-0.2,0.6-0.3
    c0.3-0.1,0.6-0.1,0.9-0.1C20.4,16.3,21.1,16.5,21.6,17z"
    />
  ),
  symbol_6: () => (
    <path
      d="M27.4,25.8c0.8-0.8,1.3-1.8,1.4-2.9l3.3-18.4c0.1-0.5-0.3-1.1-0.8-1.2c-0.5-0.1-1.1,0.3-1.2,0.8l-0.6,3.5
      c-0.7-0.3-1.4-0.5-2.2-0.5c-0.4,0-0.8,0.1-1.2,0.2l4.7-4.7c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-7.9,7.9c-0.7-0.1-1.4-0.3-2-0.8
      c-0.1,0-0.1-0.1-0.2-0.1c-0.9-0.7-2.1-1-3.3-1.1c-1.2,0.1-2.4,0.5-3.3,1.2c-0.6,0.4-1.3,0.7-2,0.8L2.9,1.3c-0.4-0.4-1-0.4-1.4,0
      s-0.4,1,0,1.4l4.7,4.7C5.8,7.3,5.3,7.2,4.9,7.2c-0.7,0-1.5,0.2-2.1,0.5L2.1,4.2C2,3.7,1.5,3.3,1,3.4C0.4,3.5,0.1,4,0.2,4.6l3.3,18.3
      C3.6,24,4.2,25,4.9,25.8l-3.5,3.5c-0.4,0.4-0.4,1,0,1.4C1.7,30.9,1.9,31,2.2,31s0.5-0.1,0.7-0.3L6.6,27c0.6,0.2,1.2,0.4,1.8,0.4
      l15.6,0c0.6,0,1.2-0.2,1.7-0.4l3.7,3.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L27.4,25.8z M25.2,10
      c0.7-0.5,1.4-0.8,2.2-0.8c0.7,0,1.3,0.2,1.8,0.6l-2.3,12.9c-0.1,0.7-0.4,1.3-0.9,1.8L17.6,16l4.8-4.8C23.4,11,24.4,10.6,25.2,10z
      M13.9,10c0.6-0.5,1.4-0.8,2.1-0.8c0.8,0,1.6,0.3,2.2,0.8c0.1,0,0.1,0.1,0.2,0.1c0.4,0.3,0.9,0.5,1.4,0.7l-3.7,3.7l-3.7-3.7
      C13,10.7,13.5,10.4,13.9,10z M5.5,22.6L3.2,9.8c0.6-0.3,1.2-0.5,1.8-0.6c0.8,0,1.6,0.3,2.2,0.8c0.8,0.6,1.7,1,2.7,1.1l4.8,4.8
      l-8.4,8.4C5.9,23.9,5.6,23.3,5.5,22.6z M23.9,25.4l-15.5,0c-0.1,0-0.2,0-0.2,0l8-8l8,8C24.1,25.4,24,25.4,23.9,25.4z"
    />
  ),
  symbol_7: () => (
    <path
      d="M31.9,25.5L27.9,8c-0.5-2.3-2.5-3.9-4.9-3.9c0,0,0,0,0,0H9.4c-0.6,0-1,0.4-1,1s0.4,1,1,1H23
      c1.4,0,2.6,0.9,2.9,2.3l1.1,5l-16.1,0c-6.1,0-11,4.9-11,11v1.5c0,1.1,0.9,2,2,2h27.9c0,0,0,0,0,0c0.2,0,0.3,0,0.4,0
      c0.5-0.1,1-0.4,1.2-0.9C31.9,26.5,32,26,31.9,25.5z M2,25.9v-1.5c0-5,4-9,9.1-9h16.5l2.4,10.5H2z M18,20.8c0,1.1-0.9,2-2,2
      s-2-0.9-2-2c0-1.1,0.9-2,2-2S18,19.7,18,20.8z"
    />
  ),
  symbol_8: () => (
    <path
      d="M31.9,25.5L27.9,8c-0.5-2.3-2.5-3.9-4.9-3.9c0,0,0,0,0,0H9.4c-0.6,0-1,0.4-1,1s0.4,1,1,1H23
      c1.4,0,2.6,0.9,2.9,2.3l1.1,5l-16.1,0c-6.1,0-11,4.9-11,11v1.5c0,1.1,0.9,2,2,2h27.9c0,0,0,0,0,0c0.2,0,0.3,0,0.4,0
      c0.5-0.1,1-0.4,1.2-0.9C31.9,26.5,32,26,31.9,25.5z M2,25.9v-1.5c0-5,4-9,9.1-9h16.5l2.4,10.5H2z M15,20.8c0,1.1-0.9,2-2,2
      s-2-0.9-2-2c0-1.1,0.9-2,2-2S15,19.7,15,20.8z M21,20.8c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-1.1,0.9-2,2-2S21,19.7,21,20.8z"
    />
  ),
  symbol_9: () => (
    <g>
      <path
        d="M31.9,25.5L27.9,8c-0.5-2.3-2.5-3.9-4.9-3.9c0,0,0,0,0,0H9.4c-0.6,0-1,0.4-1,1s0.4,1,1,1H23
        c1.4,0,2.6,0.9,2.9,2.3l1.1,5l-16.1,0c-6.1,0-11,4.9-11,11v1.5c0,1.1,0.9,2,2,2h27.9c0,0,0,0,0,0c0.2,0,0.3,0,0.4,0
        c0.5-0.1,1-0.4,1.2-0.9C31.9,26.5,32,26,31.9,25.5z M2,25.9v-1.5c0-5,4-9,9.1-9h16.5l2.4,10.5H2z"
      />
      <circle cx="10" cy="20.8" r="2" />
      <circle cx="16" cy="20.8" r="2" />
      <circle cx="22" cy="20.8" r="2" />
    </g>
  ),
  symbol_10: () => (
    <path
      d="M31.9,25.5L27.9,8c-0.1-0.6-0.4-1.2-0.8-1.7l3.6-3.6c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-3.6,3.6
      C24.9,4.4,24,4.1,23,4.1c0,0,0,0,0,0H9.4c-0.6,0-1,0.4-1,1s0.4,1,1,1H23c0.4,0,0.8,0.1,1.2,0.3l-7.1,7.1l-2.3,0L2.7,1.3
      c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L12,13.5l-1,0c-6.1,0-11,4.9-11,11v1.5c0,1.1,0.9,2,2,2h0.7l-1.4,1.4c-0.4,0.4-0.4,1,0,1.4
      C1.5,30.9,1.7,31,2,31s0.5-0.1,0.7-0.3l2.8-2.8h21l2.8,2.8c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-1.4-1.4
      h0.6c0,0,0,0,0,0c0.2,0,0.3,0,0.4,0c0.5-0.1,1-0.4,1.2-0.9C31.9,26.5,32,26,31.9,25.5z M25.7,7.7c0.1,0.2,0.2,0.4,0.3,0.7l1.1,5
      l-7.1,0L25.7,7.7z M2,25.9v-1.5c0-5,4-9,9.1-9h3l0.5,0.5l-9.9,9.9H2z M7.5,25.9l8.5-8.5l8.5,8.5H7.5z M27.3,25.9L17.4,16l0.5-0.5
      h9.6l2.4,10.5H27.3z"
    />
  ),
  symbol_11: () => (
    <path
      d="M2.9,28.3c-0.5,0-1-0.2-1.3-0.5C1.2,27.4,1,26.9,1,26.4c0-0.3,0.1-0.7,0.3-1L14.3,2.7C14.9,1.8,16.1,1.5,17,2
      c0.3,0.2,0.5,0.4,0.7,0.7c0,0,0,0,0,0l13.1,22.7c0.5,0.9,0.2,2.1-0.7,2.6c-0.3,0.2-0.6,0.2-1,0.3H2.9C2.9,28.3,2.9,28.3,2.9,28.3z
      M2.9,26.3L2.9,26.3L2.9,26.3C2.9,26.3,2.9,26.3,2.9,26.3z M16,3.8L3.1,26.3h25.9L16,3.8z"
    />
  ),
  symbol_12: () => (
    <path
      d="M30.7,26.4l-7.9-13.7l7.3-5.9c0.4-0.3,0.5-1,0.1-1.4c-0.3-0.4-1-0.5-1.4-0.1l-7,5.7l-4.2-7.3c0,0,0,0,0,0
      C17.5,3.4,17.3,3.2,17,3c-0.9-0.5-2.1-0.2-2.6,0.7l-4.2,7.3l-7-5.7C2.7,4.9,2.1,4.9,1.7,5.4C1.4,5.8,1.4,6.4,1.9,6.8l7.3,5.9
      L1.3,26.4c-0.2,0.3-0.3,0.6-0.3,1c0,0.5,0.2,1,0.6,1.3c0.4,0.4,0.8,0.5,1.3,0.5c0,0,0,0,0,0h26.2c0.3,0,0.7-0.1,1-0.3
      C31,28.5,31.3,27.3,30.7,26.4z M27.8,25.3L17.6,17l3.7-3L27.8,25.3z M27,27.3H5l11-9L27,27.3z M16,4.8l4.3,7.4L16,15.7l-4.3-3.5
      L16,4.8z M14.4,17L4.2,25.3L10.7,14L14.4,17z"
    />
  ),
  symbol_13: () => (
    <g>
      <path
        d="M29,1H3C1.9,1,1,1.9,1,3v26c0,1.1,0.9,2,2,2h26c1.1,0,2-0.9,2-2V3C31,1.9,30.1,1,29,1z M29,12.4
      c-1.3-4.7-5.1-8.3-9.8-9.4H29V12.4z M27.5,16c0,6.3-5.2,11.4-11.5,11.4C9.7,27.4,4.5,22.3,4.5,16C4.5,9.7,9.7,4.6,16,4.6
      C22.3,4.6,27.5,9.7,27.5,16z M3,3h9.8C8.1,4.1,4.3,7.8,3,12.4L3,3L3,3z M3,19.6c1.3,4.7,5.1,8.3,9.8,9.4H3L3,19.6z M19.2,29
      c4.8-1.1,8.5-4.8,9.8-9.4V29H19.2z"
      />
      <circle cx="16" cy="16" r="2" />
    </g>
  ),
  symbol_14: () => (
    <g>
      <path
        d="M29,1H3C1.9,1,1,1.9,1,3v26c0,1.1,0.9,2,2,2h26c1.1,0,2-0.9,2-2V3C31,1.9,30.1,1,29,1z M29,12.4
        c-1.3-4.7-5.1-8.3-9.8-9.4H29V12.4z M27.5,16c0,6.3-5.2,11.4-11.5,11.4C9.7,27.4,4.5,22.3,4.5,16C4.5,9.7,9.7,4.6,16,4.6
        C22.3,4.6,27.5,9.7,27.5,16z M3,3h9.8C8.1,4.1,4.3,7.8,3,12.4L3,3L3,3z M3,19.6c1.3,4.7,5.1,8.3,9.8,9.4H3L3,19.6z M19.2,29
        c4.8-1.1,8.5-4.8,9.8-9.4V29H19.2z"
      />
      <circle cx="13" cy="16" r="2" />
      <circle cx="19" cy="16" r="2" />
    </g>
  ),
  symbol_15: () => (
    <path
      d="M29,1H3C1.9,1,1,1.9,1,3v26c0,1.1,0.9,2,2,2h26c1.1,0,2-0.9,2-2V3C31,1.9,30.1,1,29,1z M29,12.4
      c-0.5-1.9-1.5-3.7-2.8-5.2L29,4.4V12.4z M14.6,16l-7.4,7.4c-1.7-2-2.7-4.6-2.7-7.4c0-2.8,1-5.4,2.7-7.4L14.6,16z M8.7,7.2
      c2-1.6,4.6-2.6,7.3-2.6c2.8,0,5.3,1,7.3,2.6L16,14.6L8.7,7.2z M16,17.4l7.3,7.3c-2,1.6-4.6,2.6-7.3,2.6c-2.8,0-5.3-1-7.3-2.6
      L16,17.4z M17.4,16l7.4-7.4c1.7,2,2.7,4.6,2.7,7.4c0,2.8-1,5.4-2.7,7.4L17.4,16z M24.8,5.8c-1.6-1.3-3.5-2.3-5.6-2.8h8.4L24.8,5.8z
      M7.2,5.8L4.4,3h8.4C10.7,3.5,8.8,4.5,7.2,5.8z M5.8,7.2C4.5,8.7,3.5,10.5,3,12.4l0-8L5.8,7.2z M3,19.6c0.5,2,1.5,3.7,2.8,5.2
      L3,27.6L3,19.6z M7.2,26.2c1.6,1.3,3.5,2.3,5.6,2.8H4.4L7.2,26.2z M24.8,26.2l2.8,2.8h-8.4C21.3,28.5,23.2,27.5,24.8,26.2z
      M26.2,24.8c1.3-1.5,2.3-3.3,2.8-5.2v8L26.2,24.8z"
    />
  ),
  symbol_16: () => (
    <path
      d="M26.2,24.8c2.1-2.4,3.3-5.4,3.3-8.8c0-3.4-1.3-6.4-3.3-8.8l4-4c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-4,4
      c-2.4-2-5.4-3.2-8.8-3.2c-3.3,0-6.4,1.2-8.8,3.2l-4-4c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l4,4C3.8,9.6,2.5,12.6,2.5,16
      c0,3.4,1.3,6.4,3.3,8.8l-4,4c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l4-4c2.4,2,5.4,3.2,8.8,3.2
      c3.3,0,6.4-1.2,8.8-3.2l4,4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L26.2,24.8z M27.5,16c0,2.8-1,5.4-2.7,7.4
      L17.4,16l7.4-7.4C26.5,10.6,27.5,13.2,27.5,16z M16,4.6c2.8,0,5.3,1,7.3,2.6L16,14.6L8.7,7.2C10.7,5.6,13.2,4.6,16,4.6z M4.5,16
      c0-2.8,1-5.4,2.7-7.4l7.4,7.4l-7.4,7.4C5.5,21.4,4.5,18.8,4.5,16z M16,27.4c-2.8,0-5.3-1-7.3-2.6l7.3-7.3l7.3,7.3
      C21.3,26.4,18.8,27.4,16,27.4z"
    />
  ),
  symbol_17: () => (
    <g>
      <path
        d="M16,2.6C8.6,2.6,2.5,8.6,2.5,16c0,7.4,6.1,13.4,13.5,13.4c7.4,0,13.5-6,13.5-13.4C29.5,8.6,23.4,2.6,16,2.6z
		     M16,27.4C9.7,27.4,4.5,22.3,4.5,16C4.5,9.7,9.7,4.6,16,4.6c6.3,0,11.5,5.1,11.5,11.4C27.5,22.3,22.3,27.4,16,27.4z"
      />
      <path
        d="M18.8,12.3c-0.6-0.5-1.3-0.7-2-0.7h-3.7v8.6h1.8v-3.1h1.8c0.8,0.1,1.5-0.2,2.2-0.6c0.5-0.6,0.8-1.4,0.7-2.2
		    C19.6,13.6,19.3,12.8,18.8,12.3z M17.5,15.4c-0.3,0.2-0.6,0.3-1,0.3h-1.6v-2.5h1.6c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.4,0.6,0.4,1
		    C17.9,14.7,17.7,15.1,17.5,15.4z"
      />
    </g>
  ),
  email: () => (
    <path
      d="M12,1C9.1,1,6.3,2.1,4.2,4.2C2.1,6.3,1,9.1,1,12c0,6.1,4.9,11,11,11c2.4,0,4.8-0.8,6.7-2.3
  c0.4-0.3,0.5-1,0.2-1.4c-0.3-0.4-1-0.5-1.4-0.2C15.9,20.3,14,21,12,21c-5,0-9-4-9-9c0-2.4,0.9-4.7,2.6-6.4C7.3,3.9,9.6,3,12,3
  c5,0,9,4,9,9v1c0,1.1-0.9,2-2,2s-2-0.9-2-2V8c0-0.6-0.4-1-1-1s-1,0.4-1,1v0c-0.8-0.6-1.9-1-3-1c-2.8,0-5,2.2-5,5s2.2,5,5,5
  c1.5,0,2.8-0.7,3.7-1.7c0.7,1,1.9,1.7,3.3,1.7c2.2,0,4-1.8,4-4v-1C23,5.9,18.1,1,12,1z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3
  S13.7,15,12,15z"
    />
  ),
  phone: () => (
    <path
      d="M19.4,23.4c-0.1,0-0.2,0-0.3,0c-3.2-0.4-6.4-1.5-9.1-3.2c-2.5-1.6-4.7-3.8-6.3-6.3C2,11.2,0.9,8,0.5,4.8
  C0.4,4,0.7,3.2,1.2,2.6c0.5-0.6,1.2-1,2-1.1c0.1,0,0.2,0,0.3,0h3c0,0,0,0,0,0c1.5,0,2.8,1.1,3,2.6C9.6,5,9.8,5.8,10.1,6.7
  c0.4,1.1,0.1,2.3-0.7,3.2l-0.7,0.7c1.2,1.8,2.7,3.4,4.6,4.6l0.7-0.7c0.8-0.8,2.1-1.1,3.2-0.7c0.8,0.3,1.7,0.5,2.6,0.6
  c1.5,0.2,2.6,1.5,2.6,3v3c0,0.8-0.3,1.6-0.9,2.1S20.2,23.4,19.4,23.4C19.4,23.4,19.4,23.4,19.4,23.4z M6.5,3.5
  C6.5,3.5,6.5,3.5,6.5,3.5h-3c-0.4,0-0.6,0.2-0.8,0.4C2.6,4.1,2.5,4.3,2.5,4.6c0.3,2.9,1.3,5.8,2.9,8.2c1.5,2.3,3.4,4.3,5.7,5.7
  c2.5,1.6,5.3,2.6,8.2,2.9c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-3c0,0,0,0,0,0c0-0.5-0.4-0.9-0.9-1
  c-1-0.1-2-0.4-3-0.8c-0.4-0.1-0.8-0.1-1.1,0.2l-1.3,1.3c-0.3,0.3-0.8,0.4-1.2,0.2c-2.7-1.5-4.9-3.7-6.4-6.4C6.4,10.5,6.5,10,6.8,9.7
  L8,8.4c0.3-0.3,0.4-0.7,0.2-1.1c-0.4-1-0.6-2-0.8-3C7.4,3.9,7,3.5,6.5,3.5z M18.4,10.5c-0.5,0-0.9-0.3-1-0.8
  c-0.3-1.6-1.6-2.8-3.2-3.2c-0.5-0.1-0.9-0.6-0.8-1.2c0.1-0.5,0.6-0.9,1.2-0.8C17,5,18.9,6.8,19.4,9.3c0.1,0.5-0.2,1.1-0.8,1.2
  C18.5,10.4,18.5,10.5,18.4,10.5z M22.4,10.4c-0.5,0-0.9-0.4-1-0.9c-0.4-3.7-3.3-6.6-7.1-7.1c-0.5-0.1-0.9-0.6-0.9-1.1
  s0.6-0.9,1.1-0.9c4.7,0.5,8.3,4.1,8.8,8.8c0.1,0.5-0.3,1-0.9,1.1C22.5,10.4,22.4,10.4,22.4,10.4z"
    />
  ),
  facebook: () => (
    <path
      d="M12.9,17.3V12h1.6l0.2-1.8h-1.8V9.3c0-0.5,0-0.7,0.8-0.7h1V6.7h-1.6c-1.9,0-2.5,0.9-2.5,2.4v1.1H9.4V12h1.2v5.3
  H12.9z M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,2C6.5,2,2,6.5,2,12
  c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10C22,6.5,17.5,2,12,2z"
    />
  ),
  favourite: () => (
    <path
      d="M12,22.7c-0.3,0-0.5-0.1-0.7-0.3l-8.8-8.8C1.2,12.4,0.5,10.7,0.5,9s0.7-3.4,1.9-4.6c2.5-2.5,6.7-2.5,9.2,0
	L12,4.8l0.4-0.4c0,0,0,0,0,0c1.2-1.2,2.9-1.9,4.6-1.9h0c1.7,0,3.4,0.7,4.6,1.9l0,0c1.2,1.2,1.9,2.9,1.9,4.6c0,1.7-0.7,3.4-1.9,4.6
	l-8.8,8.8C12.5,22.6,12.2,22.7,12,22.7z M7,4.5c-1.2,0-2.3,0.4-3.2,1.3c-1.8,1.8-1.8,4.6,0,6.4l8.1,8.1l8.1-8.1
	c0.9-0.9,1.3-2,1.3-3.2c0-1.2-0.5-2.3-1.3-3.2l0,0c-0.8-0.9-2-1.3-3.2-1.3c0,0,0,0,0,0c-1.2,0-2.3,0.5-3.2,1.3l0,0c0,0,0,0,0,0
	l-1,1.1c-0.4,0.4-1,0.4-1.4,0l-1.1-1.1C9.3,4.9,8.2,4.5,7,4.5z"
    />
  ),
  arrowLeft: () => (
    <path
      d="M13.4,8c0,0.4-0.3,0.8-0.8,0.8H5.1l3.4,3.4c0.3,0.3,0.3,0.8,0,1.1c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2
	L2.8,8.5c0,0-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.2-0.1-0.3s0-0.2,0.1-0.3c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
	l4.7-4.7c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1L5.1,7.2h7.5C13.1,7.2,13.4,7.6,13.4,8z"
    />
  ),
  arrowRight: () => (
    <path
      d="M13.3,8.4c0,0.1-0.1,0.1-0.1,0.2l-4.7,4.7c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1
	l3.4-3.4H3.3C2.9,8.8,2.6,8.4,2.6,8s0.3-0.8,0.8-0.8h7.5L7.5,3.9c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l4.7,4.7c0,0,0.1,0.1,0.1,0.2
	c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.3S13.4,8.2,13.3,8.4C13.3,8.3,13.3,8.3,13.3,8.4z"
    />
  ),
  logoSymbol: () => (
    <path
      id="Path_995"
      data-name="Path 995"
      d="M344.227,277.4a17.639,17.639,0,0,1,2.418-.756q-1.222.322-2.418.756m23.437,37.661c5.807-5,8.778-13.164,7.394-20.319a24.234,24.234,0,0,0-8.223-13.391q-.872-.755-1.8-1.436a22.2,22.2,0,0,1,10.671,13.933c2.122,8.959-2.369,19.449-10.447,24.4a22.12,22.12,0,0,1-14.489,3.092,22.975,22.975,0,0,1-3.055-.6,25.722,25.722,0,0,0,19.946-5.681M350.04,306.35c.192.074.48.187.525.3,0,.009.013.034-.018.1a1.38,1.38,0,0,1-1.354.642.739.739,0,0,1-.246-.1,11.7,11.7,0,0,1-6.18-10.372,11.319,11.319,0,0,0,3.809,7.112,13.585,13.585,0,0,0,3.2,2.208c.074.036.166.073.263.11m2.089-2.739c.322.1.49.188.544.3a.716.716,0,0,1-.08.526c-.032.075-.064.162-.1.254-.141.377-.316.846-.641.977a.864.864,0,0,1-.687-.1,14.906,14.906,0,0,1-4.749-3.48,10.032,10.032,0,0,1-2.359-4.771,9.287,9.287,0,0,1,.1-4.765,5.4,5.4,0,0,1,.279-.683c0,.033,0,.065,0,.1.007.122.015.237.023.349.015.217.031.424.032.662a14.138,14.138,0,0,0,.549,3.577,9.762,9.762,0,0,0,3.372,5.188,11.094,11.094,0,0,0,3.716,1.865m-5.586-14.227a9.16,9.16,0,0,0-.258,1.432h0a7.512,7.512,0,0,0,4.52,7.973c.336.16.688.29,1.027.417l.144.053a2.137,2.137,0,0,1,1.181,3.088c-.163.309-.3.271-.668.1a2.619,2.619,0,0,0-.242-.1c-4.443-1.489-6.737-5.081-6.293-9.854l.046-.515a12.415,12.415,0,0,1,.409-2.55c.017-.062.031-.128.049-.2a1.7,1.7,0,0,1,.271-.69c-.058.311-.122.58-.186.842m11.016.179A12.338,12.338,0,0,1,362,292.875l-.3-.193a15.42,15.42,0,0,0-4.577-2.275,13.64,13.64,0,0,0-8.6,1.189c-.108.048-.224.114-.346.182-.348.2-.624.34-.744.207-.034-.037-.082-.192-.015-.517a2.027,2.027,0,0,1,.7-1.239c3.587-1.595,6.588-1.8,9.45-.666m-3.089,12.607a19.715,19.715,0,0,0-.02-3.643,2.114,2.114,0,0,1,.6-1.312,2.186,2.186,0,0,1,1.238-.83c.178-.007.2,0,.231.3l.009.074c.972,7.2-2.435,11.741-9.594,12.8a1.052,1.052,0,0,1-.464-.006l-.134-.082a.3.3,0,0,1-.04-.045l.542-.077a17.364,17.364,0,0,0,1.735-.3,7.4,7.4,0,0,0,5.9-6.875m6.593-5.123c-.006-.091-.02-.195-.036-.307-.033-.242-.084-.609.01-.729.008-.01.027-.034.1-.042.524-.06.924.313,1.077,1.013a8.59,8.59,0,0,1-1.4,7.25,16.05,16.05,0,0,1-7.957,5.448,16.484,16.484,0,0,0,4.457-2.455,12.209,12.209,0,0,0,3.758-10.178m-3.418,5q.037-.443.077-.881a18.47,18.47,0,0,0,.032-4.6.947.947,0,0,1,.059-.7c.094-.119.3-.186.653-.214.094-.007.182-.017.271-.027a3.688,3.688,0,0,1,.381-.031c.327,0,.5.127.584.7a11.284,11.284,0,0,1-6.22,11.88c2.121-1.691,4-4.142,4.162-6.131m-2.939-10.654a10.018,10.018,0,0,1,6.163,2.145l-.538-.263c-.495-.242-.963-.472-1.268-.6-3.827-1.583-7.158-.708-9.638,2.525-.339.443-.5.505-.586.5-.151-.008-.346-.3-.517-.573-.4-.652-.628-1.115-.541-1.407s.553-.57,1.32-.927a13.215,13.215,0,0,1,5.6-1.4m-4.083,5.859c-.137-.106-.27-.21-.4-.3-.1-.068-.214-.167-.227-.268-.017-.133.143-.321.285-.485a2.89,2.89,0,0,0,.212-.266,6.11,6.11,0,0,1,4.207-2.654,6.761,6.761,0,0,1,1.01-.076,6.856,6.856,0,0,1,3.668,1.062c-2.746.178-4.827,1.509-7.053,3.437-.495.426-.995.1-1.7-.452m14.754,4.771-.23-.024-.058.218c-.084.279-.174.56-.266.841-.039.117-.08.23-.121.345l-.137.343c-.074.173-.147.344-.242.541-.038.087-.079.171-.1.217l-.043.074c-.04.081-.083.161-.128.242s-.081.154-.126.229A13.136,13.136,0,0,1,355.3,311.2l-.328.056a12.245,12.245,0,0,1-2.323.142l-.06-.008-.017.006c-.075,0-.153-.007-.23-.013s-.179-.015-.27-.026c-.04,0-.48-.055-.976-.123a20.19,20.19,0,0,0,4.652-1.368c3.906-1.933,6.183-4.172,7.382-7.255a9.257,9.257,0,0,0,.553-4.5,1.92,1.92,0,0,0-.046-.238c-.064-.265-.051-.3,0-.327.177-.089.29-.014.523.2l.084.074a3.252,3.252,0,0,1,1.125,3.121c-.057.346-.131.692-.216,1.029Zm-16.108-15.045.031-.01a12.5,12.5,0,0,1,15.618,8.045c-1.537-2.523-3.487-5.133-6.617-6.507a11.008,11.008,0,0,0-4.482-.945,15.55,15.55,0,0,0-5.607,1.171c.186-1.125.377-1.48,1.058-1.753Zm-8.66,13.3c-.024-.212-.043-.425-.054-.637l-.011-.262c-.007-.2-.01-.4-.01-.605,0-.061,0-.119,0-.184l.007-.2c.006-.11.01-.221.019-.332s.015-.222.028-.332c.009-.086.017-.171.031-.261,0-.048.012-.1.02-.158l.025-.154a12.144,12.144,0,0,1,.3-1.446,13.227,13.227,0,0,1,.923-2.444c-1.229,6.161.625,11.047,5.52,14.536a3.183,3.183,0,0,1-3.772-.671,13.075,13.075,0,0,1-3.02-6.8l-.234-.026.228-.018Zm-5.4,1.387c1.892,2.794,6.758,7.2,10.1,8.642a13.826,13.826,0,0,0,7.739,2.378,13.983,13.983,0,0,0,1.95-.138c.211-.031.422-.064.626-.105s.391-.076.584-.123c.417-.1.813-.21,1.179-.332l.08-.028a13.386,13.386,0,0,0,2.432-1.1l.042-.02a10.174,10.174,0,0,0,2.325-1.69h.075l.032-.1.078-.073a13.415,13.415,0,0,0,1.853-2.131l.069-.071v-.013a5.667,5.667,0,0,0,.516-.806l.036-.035v-.032a13.585,13.585,0,0,0,1.241-2.781l0-.01a7.237,7.237,0,0,0,.235-.834,13.587,13.587,0,0,0,.415-3.383c0-.169,0-.34-.007-.512-.022-.48-.064-.95-.134-1.434a13.744,13.744,0,0,0-10.716-11.5l-.048.224.032-.228c-.12-.03-.243-.054-.354-.074a1.441,1.441,0,0,0-.157-.03,14.245,14.245,0,0,0-4.124-.15,13.063,13.063,0,0,0-7.69,3.647c-.036.033-.07.066-.127.123a13.783,13.783,0,0,0-3.712,6.158l-.016.055a13.016,13.016,0,0,0,.219,8.182,13.644,13.644,0,0,0,1.276,2.725,27.265,27.265,0,0,1-4.95-5.156,15.734,15.734,0,0,1-1.72-13.878,15.328,15.328,0,0,1,1.863-3.6,26.559,26.559,0,0,1,20.8-6.129,26.243,26.243,0,0,1,8.714,5.048A22.912,22.912,0,0,1,373.75,295c1.3,6.7-1.5,14.358-6.955,19.057a25.347,25.347,0,0,1-26.423,3.239,20.972,20.972,0,0,1-2.185-1.8c-2.368-2.235-6.4-6.911-6.834-13.1-.022-.307-.048-.6-.074-.885-.155-1.739-.315-3.536.629-9.85a8.041,8.041,0,0,1,.647-1.95,17.045,17.045,0,0,0,2.65,11.948m-4.615-10.2c-.967,6.473-.8,8.35-.636,10.166.024.28.049.561.07.858a20.105,20.105,0,0,0,4.307,10.708,17.743,17.743,0,0,1-5.662-13.909,21.364,21.364,0,0,1,2.044-8.41,5.87,5.87,0,0,0-.123.586m46.416,2.076a23.565,23.565,0,0,0-12.937-15.611,24.055,24.055,0,0,0-6.474-1.908,21.465,21.465,0,0,0-8.953-1.062A18.713,18.713,0,0,0,335.5,282.5a24.527,24.527,0,0,0-5.148,6.205,20.423,20.423,0,0,0,9.318,29.729,24.167,24.167,0,0,0,10.931,4.233,24.5,24.5,0,0,0,3.08.2,23.325,23.325,0,0,0,12.273-3.474,25.165,25.165,0,0,0,11.6-20.143,21.582,21.582,0,0,0-.552-5.7"
      transform="translate(-327.302 -274.864)"
      fill="#07151c"
    />
  ),
  ball: () => (
    <path
      d="M44,42.5h-9.1c4.3-2.5,7.6-6.5,9.3-11.2l0.5-0.5l-0.2-0.2c0.7-2.1,1.1-4.3,1.1-6.7c0-2.3-0.4-4.6-1.1-6.7
      l0.2-0.2l-0.5-0.5C42,10.7,37.3,6,31.3,3.8l-0.5-0.5l-0.2,0.2c-2.1-0.7-4.3-1.1-6.7-1.1c-2.3,0-4.6,0.4-6.7,1.1l-0.2-0.2l-0.5,0.5
      C10.7,6,6,10.7,3.8,16.7l-0.5,0.5l0.2,0.2c-0.7,2.1-1.1,4.3-1.1,6.7c0,2.3,0.4,4.6,1.1,6.7l-0.2,0.2l0.5,0.5
      c2.2,6,6.9,10.7,12.9,12.9l0.5,0.5l0.2-0.2c2.1,0.7,4.3,1.1,6.7,1.1h20c0.8,0,1.5-0.7,1.5-1.5S44.8,42.5,44,42.5z M38.1,36l-7.2-7.2
      l-5.8-5.8l-5.8-5.8L12,9.9c1.4-1.2,2.9-2.1,4.6-2.9l6.3,6.3l5.8,5.8l0,0l5.8,5.8l0,0l6.3,6.3C40.2,33.1,39.2,34.6,38.1,36z
       M29.8,16.1l-3.7-3.7l5.3-5.3c1.7,0.7,3.2,1.7,4.6,2.9L29.8,16.1z M42.5,24c0,1.5-0.2,2.9-0.5,4.2L37.8,24l4.2-4.2
      C42.3,21.1,42.5,22.5,42.5,24z M40.9,16.6l-5.3,5.3L32,18.2l6.1-6.1C39.2,13.4,40.2,14.9,40.9,16.6z M24,5.5c1.5,0,2.9,0.2,4.2,0.5
      L24,10.2L19.8,6C21.1,5.7,22.5,5.5,24,5.5z M9.9,12l7.2,7.2l5.8,5.8l5.8,5.8l7.2,7.2c-1.4,1.2-2.9,2.1-4.6,2.9l-6.3-6.3l0,0
      l-5.8-5.8l0,0l-5.8-5.8L12.3,24l0,0l1.1-1.1l-6.3-6.3C7.8,14.9,8.8,13.4,9.9,12z M18.2,32l3.7,3.7l-5.3,5.3
      c-1.7-0.7-3.2-1.7-4.6-2.9L18.2,32z M5.5,24c0-1.5,0.2-2.9,0.5-4.2l4.2,4.2L6,28.2C5.7,26.9,5.5,25.5,5.5,24z M7.1,31.4l5.3-5.3
      l3.7,3.7L9.9,36C8.8,34.6,7.8,33.1,7.1,31.4z M24,37.8l4.2,4.2c-1.4,0.3-2.8,0.5-4.2,0.5c-1.5,0-2.9-0.2-4.2-0.5L24,37.8z"
    />
  ),
  heart: () => (
    <path
      d="M41.8,8c-2.4-2.3-5.5-3.6-8.8-3.5c-3.3,0-6.5,1.3-9,3.5c-2.4-2.2-5.6-3.5-9-3.5h-0.2c-3.3,0-6.4,1.4-8.7,3.7
      c-2.3,2.4-3.6,5.5-3.5,8.8c0,8.2,7,14.6,17.6,24.2l2.9,2.6c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4l3-2.7
      C38.5,31.5,45.5,25.2,45.5,17v-0.2C45.5,13.5,44.1,10.4,41.8,8z M40.5,11.1C40.5,11.1,40.5,11.1,40.5,11.1l-7,6.9l-2.7-2.7l6.9-6.7
      c0.7,0.4,1.4,0.9,2,1.5C40,10.5,40.3,10.8,40.5,11.1z M33,7.5c0.5,0,1,0,1.5,0.1l-5.8,5.7l-2.9-2.8C27.7,8.6,30.3,7.5,33,7.5z
       M10.3,8.7l7.7,7.7l4.8,4.8l4.8,4.8l5.9,5.9c-0.9,0.8-1.8,1.7-2.7,2.6l-5.8-5.8l-4.8-4.8c0,0,0,0,0,0l-4.8-4.8l0,0l0,0c0,0,0,0,0,0
      c0,0,0,0,0,0l-7.8-7.9c0,0-0.1,0-0.1-0.1c0.2-0.3,0.4-0.5,0.7-0.8C8.8,9.7,9.5,9.1,10.3,8.7z M14.4,31.8l4.7-4.7l2.7,2.7l-4.6,4.6
      C16.2,33.5,15.2,32.6,14.4,31.8z M9.8,26.8l4.5-4.5l2.7,2.7l-4.7,4.7C11.4,28.7,10.5,27.7,9.8,26.8z M6,13.9l6.2,6.3L8,24.3
      c-1.6-2.5-2.5-4.8-2.5-7.4C5.5,15.9,5.7,14.9,6,13.9z M26,38.9l-2,1.8l-1.9-1.7c-1-0.9-1.9-1.7-2.8-2.5l4.6-4.6l4.7,4.7
      C27.7,37.3,26.9,38.1,26,38.9z M35.6,29.8l-5.9-5.9l-4.8-4.8l-4.8-4.8l-6.7-6.7c0.4-0.1,0.9-0.1,1.3-0.1H15c1.6,0,3.1,0.4,4.4,1
      c0,0,0,0,0,0.1l8.2,7.8l4.8,4.8c0,0,0,0,0,0s0,0,0,0l0,0l5.7,5.7C37.4,27.9,36.5,28.8,35.6,29.8z M42.5,17c0,2.6-0.9,5-2.6,7.5
      l-4.3-4.3l6.4-6.3c0.3,0.9,0.5,1.9,0.5,3V17z"
    />
  ),
  calendar: () => (
    <path
      d="M37,26h-8c-0.8,0-1.5,0.7-1.5,1.5v8c0,0.8,0.7,1.5,1.5,1.5h8c0.8,0,1.5-0.7,1.5-1.5v-8C38.5,26.6,37.8,26,37,26
      z M35.5,34h-5v-5h5V34z M40,7h-3c0-2.2-1.8-4-4-4s-4,1.8-4,4H19V6.8C19,4.7,17.3,3,15.2,3h-0.4C12.7,3,11,4.7,11,6.8V7H8
      c-3,0-5.5,2.5-5.5,5.5v26C2.5,41.5,5,44,8,44h32c3,0,5.5-2.5,5.5-5.5v-26C45.5,9.4,43,7,40,7z M32,7c0-0.6,0.4-1,1-1s1,0.4,1,1v6
      c0,0.6-0.4,1-1,1s-1-0.4-1-1V7z M14,6.8C14,6.4,14.4,6,14.8,6h0.4C15.6,6,16,6.4,16,6.8v6.4c0,0.4-0.4,0.8-0.8,0.8h-0.4
      c-0.4,0-0.8-0.4-0.8-0.8V6.8z M42.5,38.5c0,1.4-1.1,2.5-2.5,2.5H8c-1.4,0-2.5-1.1-2.5-2.5v-26C5.5,11.1,6.6,10,8,10h3v3.2
      c0,2.1,1.7,3.8,3.8,3.8h0.4c2.1,0,3.8-1.7,3.8-3.8V10h10v3c0,2.2,1.8,4,4,4s4-1.8,4-4v-3h3c1.4,0,2.5,1.1,2.5,2.5V38.5z"
    />
  ),
  rightArrow: () => (
    <path
      d="M13.3,8.4c0,0.1-0.1,0.1-0.1,0.2l-4.7,4.7c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1
      l3.4-3.4H3.3C2.9,8.8,2.6,8.4,2.6,8s0.3-0.8,0.8-0.8h7.5L7.5,3.9c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l4.7,4.7c0,0,0.1,0.1,0.1,0.2
      c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.3S13.4,8.2,13.3,8.4C13.3,8.3,13.3,8.3,13.3,8.4z"
    />
  ),
  leftArrow: () => (
    <path
      d="M13.4,8c0,0.4-0.3,0.8-0.8,0.8H5.1l3.4,3.4c0.3,0.3,0.3,0.8,0,1.1c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2
      L2.8,8.5c0,0-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.2-0.1-0.3s0-0.2,0.1-0.3c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
      l4.7-4.7c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1L5.1,7.2h7.5C13.1,7.2,13.4,7.6,13.4,8z"
    />
  ),
  listMenu: () => (
    <path
      d="M21,13H3c-0.6,0-1-0.4-1-1s0.4-1,1-1h18c0.6,0,1,0.4,1,1S21.6,13,21,13z M22,6c0-0.6-0.4-1-1-1H3
      C2.4,5,2,5.4,2,6s0.4,1,1,1h18C21.6,7,22,6.6,22,6z M22,18c0-0.6-0.4-1-1-1H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h18C21.6,19,22,18.6,22,18z"
    />
  ),
  listMenuMobile: () => (
    <path
      d="M2,6c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1s-0.4,1-1,1H3C2.4,7,2,6.6,2,6z M3,2h18c0.6,0,1-0.4,1-1s-0.4-1-1-1H3
      C2.4,0,2,0.4,2,1S2.4,2,3,2z M3,12h18c0.6,0,1-0.4,1-1s-0.4-1-1-1H3c-0.6,0-1,0.4-1,1S2.4,12,3,12z M23.2,18.6H23
      c-0.4,0-0.6,0.2-0.6,0.7v2.6c-0.2,0.4-0.6,0.6-1.1,0.6c-0.6,0-0.9-0.4-0.9-1v-2.2c0-0.5-0.3-0.7-0.6-0.7h-0.2
      c-0.4,0-0.6,0.2-0.6,0.7v2.4c0,1.1,0.5,2,1.8,2c0.7,0,1.3-0.3,1.6-0.9c0,0.1,0,0.2,0,0.3c0.1,0.3,0.4,0.6,0.8,0.5
      c0.3,0,0.5-0.1,0.5-0.2v-4.1C23.8,18.7,23.5,18.6,23.2,18.6z M12.5,21L12.5,21c0,0.3-0.1,0.5-0.3,0.5H8.8l0,0.2
      c0.1,0.6,0.7,1.1,1.4,1c0.6,0,1.1-0.2,1.4-0.7c0,0,0.7,0,0.7,0.6c0,0.3-0.2,0.6-0.5,0.8c-0.5,0.3-1,0.4-1.6,0.4c-0.1,0-0.2,0-0.3,0
      c-1.3-0.1-2.4-1.2-2.3-2.5c0-0.1,0-0.1,0-0.2c0-1.4,1.2-2.5,2.5-2.4c0.1,0,0.2,0,0.2,0C11.6,18.6,12.5,19.7,12.5,21z M11.2,20.6
      c0-0.6-0.5-1.1-1.1-1.1c-0.7,0-1.2,0.5-1.3,1.2L11.2,20.6C11.2,20.6,11.2,20.6,11.2,20.6z M16.6,18.5c-0.1,0-0.2,0-0.3,0
      c-0.7,0-1.3,0.3-1.6,0.9c0-0.4-0.4-0.8-0.8-0.8c0,0,0,0,0,0c-0.3,0-0.5,0.1-0.5,0.2v4.1c0,0.5,0.3,0.7,0.6,0.7h0.2
      c0.4,0,0.6-0.2,0.6-0.7v-2.5c0.2-0.4,0.6-0.6,1.1-0.6c0.6,0,0.9,0.4,0.9,1v2.1c0,0.5,0.3,0.7,0.6,0.7h0.1c0.4,0,0.6-0.2,0.6-0.7
      v-2.3C18.2,19.6,17.5,18.7,16.6,18.5z M6.1,17c0,0-0.1,0-0.1,0H5.5c-0.4,0-0.6,0.1-0.8,0.5l-1.3,3l-1.3-3c-0.1-0.3-0.4-0.6-0.8-0.5
      H1c-0.4,0-0.7,0.2-0.7,0.6c0,0,0,0.1,0,0.1v5.1c0,0.4,0.2,0.7,0.6,0.7H1c0.4,0,0.6-0.2,0.6-0.7v-3.8l1.1,2.6
      c0.1,0.2,0.2,0.5,0.7,0.5s0.6-0.2,0.8-0.5L5.3,19v3.9c0,0.4,0.2,0.7,0.6,0.7h0.2c0.4,0,0.6-0.2,0.6-0.7v-5.1C6.7,17.4,6.4,17,6.1,17
      z"
    />
  ),
  search: () => (
    <path
      d="M21.7,20.3L18,16.6c1.2-1.5,2-3.5,2-5.6c0-5-4-9-9-9c-5,0-9,4-9,9c0,5,4,9,9,9c2.1,0,4.1-0.7,5.6-2l3.7,3.7
      c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3C22.1,21.3,22.1,20.7,21.7,20.3z M4,11c0-3.9,3.1-7,7-7c3.9,0,7,3.1,7,7
      c0,1.9-0.8,3.7-2,4.9c0,0,0,0,0,0s0,0,0,0c-1.3,1.3-3,2-4.9,2C7.1,18,4,14.9,4,11z"
    />
  ),
  account: () => (
    <path
      d="M21,19v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2c0-1.7-1.3-3-3-3H8c-1.7,0-3,1.3-3,3v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2
      c0-2.8,2.2-5,5-5h8C18.8,14,21,16.2,21,19z M7,7c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S7,9.8,7,7z M9,7c0,1.7,1.3,3,3,3s3-1.3,3-3
      s-1.3-3-3-3S9,5.3,9,7z"
    />
  ),
  downArrow: () => (
    <path
      d="M12,16c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5.3,5.3l5.3-5.3c0.4-0.4,1-0.4,1.4,0
    s0.4,1,0,1.4l-6,6C12.5,15.9,12.3,16,12,16z"
    />
  ),
  upArrow: () => (
    <path
      d="M18,16c-0.3,0-0.5-0.1-0.7-0.3L12,10.4l-5.3,5.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0
      l6,6c0.4,0.4,0.4,1,0,1.4C18.5,15.9,18.3,16,18,16z"
    />
  ),
  minus: () => (
    <path
      d="M6.7,5.3c-0.4,0.4-1,0.4-1.4,0L1.7,1.7c-0.4-0.4-0.4-1,0-1.4C1.9,0.1,2.1,0,2.4,0h7.2c0.6,0,1,0.4,1,1
      c0,0.3-0.1,0.5-0.3,0.7L6.7,5.3z"
    />
  ),
  plus: () => (
    <path
      d="M5.3,0.7c0.4-0.4,1-0.4,1.4,0l3.6,3.6c0.4,0.4,0.4,1,0,1.4C10.1,5.9,9.9,6,9.6,6H2.4c-0.6,0-1-0.4-1-1
      c0-0.3,0.1-0.5,0.3-0.7L5.3,0.7z"
    />
  ),
  gallery: () => (
    <path
      d="M21,22H3c-1.7,0-3-1.3-3-3V8c0-1.7,1.3-3,3-3h3.5l1.7-2.6C8.4,2.2,8.7,2,9,2h6c0.3,0,0.6,0.2,0.8,0.4L17.5,5H21
      c1.7,0,3,1.3,3,3v11C24,20.7,22.7,22,21,22z M3,7C2.4,7,2,7.4,2,8v11c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V8c0-0.6-0.4-1-1-1h-4
      c-0.3,0-0.6-0.2-0.8-0.4L14.5,4H9.5L7.8,6.6C7.6,6.8,7.3,7,7,7H3z M12,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S14.8,18,12,18z
       M12,10c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.7,10,12,10z"
    />
  ),
  check: () => (
    <path
      d="M6,12.3c-0.3,0-0.5-0.1-0.7-0.3L2,8.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L6,9.9l6.6-6.6c0.4-0.4,1-0.4,1.4,0
      s0.4,1,0,1.4L6.7,12C6.5,12.2,6.3,12.3,6,12.3z"
    />
  ),
  x: () => (
    <path
      d="M13.4,12l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L12,10.6L6.7,5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l5.3,5.3
	l-5.3,5.3c-0.4,0.4-0.4,1,0,1.4C5.5,18.9,5.7,19,6,19s0.5-0.1,0.7-0.3l5.3-5.3l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3
	c0.4-0.4,0.4-1,0-1.4L13.4,12z"
    />
  ),
  cart: () => (
    <path
      d="M8,24c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,24,8,24z M21,22c0-1.1-0.9-2-2-2s-2,0.9-2,2s0.9,2,2,2
	S21,23.1,21,22z M8.7,18h9.7c1.5,0,2.7-1,3-2.4L23,7.2c0.1-0.3,0-0.6-0.2-0.8C22.6,6.1,22.3,6,22,6H5.8L5,1.8C4.9,1.3,4.5,1,4,1H2
	C1.4,1,1,1.4,1,2s0.4,1,1,1h1.2L4,7.2c0,0,0,0.1,0,0.1l1.7,8.3C6,17,7.2,18,8.7,18C8.6,18,8.7,18,8.7,18z M20.8,8l-1.4,7.2
	c-0.1,0.5-0.5,0.8-1,0.8H8.7c-0.5,0-0.9-0.3-1-0.8L6.2,8H20.8z"
    />
  ),
  chevronRight: () => (
    <path
      d="M9,19c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l5.3-5.3L8.3,6.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l6,6
	c0.4,0.4,0.4,1,0,1.4l-6,6C9.5,18.9,9.3,19,9,19z"
    />
  ),
  chevronRightSmall: () => (
    <path
      d="M6,13c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L8.6,8L5.3,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l4,4
	c0.4,0.4,0.4,1,0,1.4l-4,4C6.5,12.9,6.3,13,6,13z"
    />
  ),
  chevronLeft: () => (
    <path
      d="M15,19c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L10.4,12l5.3,5.3
	c0.4,0.4,0.4,1,0,1.4C15.5,18.9,15.3,19,15,19z"
    />
  ),
  chevronLeftSmall: () => (
    <path
      d="M10,13c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4l4-4c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L7.4,8l3.3,3.3
	c0.4,0.4,0.4,1,0,1.4C10.5,12.9,10.3,13,10,13z"
    />
  ),
  xSmall: () => (
    <path
      d="M12.7,11.3c0.4,0.4,0.4,1,0,1.4C12.5,12.9,12.3,13,12,13s-0.5-0.1-0.7-0.3L8,9.4l-3.3,3.3C4.5,12.9,4.3,13,4,13
	s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L6.6,8L3.3,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L8,6.6l3.3-3.3c0.4-0.4,1-0.4,1.4,0
	s0.4,1,0,1.4L9.4,8L12.7,11.3z"
    />
  ),
  cardView: () => (
    <path
      d="M20,22H4c-1.7,0-3-1.3-3-3V5c0-1.7,1.3-3,3-3h5c0.3,0,0.6,0.2,0.8,0.4L11.5,5H20c1.7,0,3,1.3,3,3v11
	C23,20.7,21.7,22,20,22z M4,4C3.4,4,3,4.4,3,5v14c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8c0-0.6-0.4-1-1-1h-9c-0.3,0-0.6-0.2-0.8-0.4
	L8.5,4H4z"
    />
  ),
  filter: () => (
    <path
      d="M14,22c-0.2,0-0.3,0-0.4-0.1l-4-2C9.2,19.7,9,19.4,9,19v-6.2L1.2,3.6C1,3.3,0.9,2.9,1.1,2.6C1.3,2.2,1.6,2,2,2
	h20c0.4,0,0.7,0.2,0.9,0.6s0.1,0.8-0.1,1.1L15,12.8V21c0,0.3-0.2,0.7-0.5,0.9C14.4,22,14.2,22,14,22z M11,18.4l2,1v-6.9
	c0-0.2,0.1-0.5,0.2-0.6L19.8,4H4.2l6.6,7.8c0.2,0.2,0.2,0.4,0.2,0.6V18.4z"
    />
  ),
  chevronDownSmall: () => (
    <path
      d="M8,11c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L8,8.6l3.3-3.3c0.4-0.4,1-0.4,1.4,0
	s0.4,1,0,1.4l-4,4C8.5,10.9,8.3,11,8,11z"
    />
  ),
  chevronUpSmall: () => (
    <path
      d="M12,11c-0.3,0-0.5-0.1-0.7-0.3L8,7.4l-3.3,3.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l4-4c0.4-0.4,1-0.4,1.4,0l4,4
	c0.4,0.4,0.4,1,0,1.4C12.5,10.9,12.3,11,12,11z"
    />
  ),
  newAddress: () => (
    <path
      d="M22,24.5h-6.2c-0.6,0-1-0.4-1-1v-5.8h-4.7v5.8c0,0.6-0.4,1-1,1H3c-0.8,0-1.5-0.6-1.5-1.4v-13
	c0-0.3,0.1-0.6,0.3-0.8l10-8.6l1.3,1.5l-9.7,8.3v11.9h4.7v-5.8c0-0.6,0.4-1,1-1h6.7c0.6,0,1,0.4,1,1v5.8h4.7V10.3h2v12.8
	C23.5,23.9,22.8,24.5,22,24.5z M20.5,8.5v-3h3v-2h-3v-3h-2v3h-3v2h3v3H20.5z"
    />
  ),
  // stare ikonky zo sanitasu
  login: () => (
    <path
      d="M12.1,6.6V4.7c0-2.3-1.8-4.1-4.1-4.1S3.9,2.4,3.9,4.7v1.9c-1.5,0-2.7,1.3-2.7,2.7v3.3c0,1.5,1.2,2.8,2.8,2.8h8
	c1.5,0,2.8-1.2,2.8-2.8V9.3C14.8,7.8,13.6,6.6,12.1,6.6z M8,2.1c1.4,0,2.6,1.2,2.6,2.6v1.9H5.4V4.7C5.4,3.2,6.6,2.1,8,2.1z
	 M13.3,12.7c0,0.7-0.6,1.3-1.3,1.3H4c-0.7,0-1.3-0.6-1.3-1.3V9.3c0-0.7,0.6-1.3,1.3-1.3h8c0.7,0,1.3,0.6,1.3,1.3V12.7z"
    />
  ),
  scroll: () => (
    <path
      d="M25.7,6.1l-4,4c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l2.3-2.3H3.4l2.3,2.3c0.4,0.4,0.4,1,0,1.4
	c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4l4-4c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L3.4,4.4h19.2l-2.3-2.3
	c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l4,4C26.1,5.1,26.1,5.7,25.7,6.1z"
    />
  ),
  download: () => (
    <path
      d="M14.8,10v2.7c0,1.1-0.9,2.1-2.1,2.1H3.3c-1.1,0-2.1-0.9-2.1-2.1V10c0-0.4,0.3-0.8,0.8-0.8S2.8,9.6,2.8,10v2.7
	c0,0.3,0.3,0.6,0.6,0.6h9.3c0.3,0,0.6-0.3,0.6-0.6V10c0-0.4,0.3-0.8,0.8-0.8S14.8,9.6,14.8,10z M7.5,10.5c0.1,0.1,0.2,0.1,0.2,0.2
	c0.1,0,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2l3.3-3.3c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0L8.8,8.2V2
	c0-0.4-0.3-0.8-0.8-0.8S7.3,1.6,7.3,2v6.2L5.2,6.1c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1L7.5,10.5z"
    />
  ),
  listView: () => (
    <path
      d="M0,1c0-0.6,0.4-1,1-1h20c0.6,0,1,0.4,1,1s-0.4,1-1,1H1C0.4,2,0,1.6,0,1z M21,8H1C0.4,8,0,8.4,0,9s0.4,1,1,1h20
	c0.6,0,1-0.4,1-1S21.6,8,21,8z M21,16H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h20c0.6,0,1-0.4,1-1S21.6,16,21,16z"
    />
  ),
  user: () => (
    <path
      d="M23,18.6v2.8c0,1-0.4,2.1-1.4,2.1h-19c-1.1,0-1.6-1.6-1.6-2.1v-2.8c0-3,2.9-5.5,7-6.5c-1.5-1.2-2.5-3-2.5-5.1
	c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5c0,2.1-1,3.9-2.5,5.1C20.1,13.1,23,15.6,23,18.6z M7.5,7c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5
	s-2-4.5-4.5-4.5S7.5,4.5,7.5,7z M21,18.6c0-2.7-4.1-5-9-5c-4.9,0-9,2.3-9,5v2.8c0,0,0,0,0,0.1H21c0,0,0-0.1,0-0.1V18.6z"
    />
  ),
  close: () => (
    <path
      d="M13.4,12l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L12,10.6L6.7,5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l5.3,5.3
      l-5.3,5.3c-0.4,0.4-0.4,1,0,1.4C5.5,18.9,5.7,19,6,19s0.5-0.1,0.7-0.3l5.3-5.3l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3
      c0.4-0.4,0.4-1,0-1.4L13.4,12z"
    />
  ),
  back: () => <path id="arrow" d="M5.5,12,0,6,5.5,0,7,1.4,2.7,6,7,10.6Z" />,
  upload: () => (
    <path
      d="M22,16.8v5c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v4h16v-4c0-0.6,0.4-1,1-1S22,16.2,22,16.8z
	 M5.3,10c0.3,0,0.5-0.1,0.7-0.3l5-4.9l0,11.6c0,0.6,0.4,1,1,1c0,0,0,0,0,0c0.6,0,1-0.5,1-1l0-11.6l5.1,4.9c0.4,0.4,1,0.4,1.4,0
	c0.4-0.4,0.4-1,0-1.4l-6.8-6.5c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0
	c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0L4.6,8.3c-0.4,0.4-0.4,1,0,1.4C4.7,9.9,5,10,5.3,10z"
    />
  ),
  success: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  error: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  document: () => (
    <path d="M14,2H6C4.9,2,4,2.9,4,4l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v5h5v11H6z" />
  ),
  refresh: () => (
    <path
      d="M17.6,6.3c-3.1-3.1-8.2-3.1-11.3,0s-3.1,8.2,0,11.3s8.2,3.1,11.3,0c1-1,1.7-2.3,2.1-3.7h-2.1c-1.1,3.1-4.5,4.8-7.7,3.7
	S5.2,13.1,6.3,10C7.2,7.6,9.5,6,12,6c1.6,0,3.1,0.6,4.2,1.8L13,11h7V4L17.6,6.3z"
    />
  ),
  paid: () => (
    <path
      d="M12,22.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z M12,3.5
	c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C20.5,7.3,16.7,3.5,12,3.5z M11.5,15.2l5.3-5
	c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-4.6,4.3l-2-2.1c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l2.7,2.8
	c0.2,0.2,0.5,0.3,0.7,0.3C11,15.5,11.3,15.4,11.5,15.2z"
    />
  ),
  time: () => (
    <path
      d="M12,22.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z M12,3.5
	c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C20.5,7.3,16.7,3.5,12,3.5z M16.5,14.5c0.2-0.5,0-1.1-0.4-1.3
	l-3.2-1.6v-5c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0.4,0.2,0.7,0.6,0.9l3.7,1.9c0.1,0.1,0.3,0.1,0.4,0.1C16,15,16.3,14.8,16.5,14.5z"
    />
  ),
  inwork: () => (
    <path
      d="M17,4h-1c0-1.1-0.9-2-2-2h-4C8.9,2,8,2.9,8,4H7C5.3,4,4,5.3,4,7v12c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V7
	C20,5.3,18.7,4,17,4z M10,4h4v2h-4V4L10,4z M18,19c0,0.6-0.4,1-1,1H7c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1h1c0,1.1,0.9,2,2,2h4
	c1.1,0,2-0.9,2-2h1c0.6,0,1,0.4,1,1V19z"
    />
  ),
  checked: () => (
    <path
      d="M6,12.3c-0.3,0-0.5-0.1-0.7-0.3L2,8.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L6,9.9l6.6-6.6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4
	L6.7,12C6.5,12.2,6.3,12.3,6,12.3z"
    />
  ),
  trash: () => (
    <path
      d="M14,3.3h-2.6V2.7c0-1.1-0.9-2.1-2.1-2.1H6.7c-1.1,0-2.1,0.9-2.1,2.1v0.6H2C1.6,3.3,1.3,3.6,1.3,4S1.6,4.8,2,4.8h0.6v8.6
	c0,1.1,0.9,2.1,2.1,2.1h6.7c1.1,0,2.1-0.9,2.1-2.1V4.8H14c0.4,0,0.8-0.3,0.8-0.8S14.4,3.3,14,3.3z M6.1,2.7c0-0.3,0.3-0.6,0.6-0.6
	h2.7c0.3,0,0.6,0.3,0.6,0.6v0.6H6.1V2.7z M11.9,13.3c0,0.3-0.3,0.6-0.6,0.6H4.7c-0.3,0-0.6-0.3-0.6-0.6V4.8h7.8V13.3z M7.4,7.3v4
	c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8v-4c0-0.4,0.3-0.8,0.8-0.8S7.4,6.9,7.4,7.3z M10.1,7.3v4c0,0.4-0.3,0.8-0.8,0.8
	s-0.8-0.3-0.8-0.8v-4c0-0.4,0.3-0.8,0.8-0.8S10.1,6.9,10.1,7.3z"
    />
  ),
  cartDone: () => (
    <>
      <defs>
        <style>
          {` .cls-1 {
        fill: none;
      }

      .cls-2, .cls-4 {
        fill: #A5BBA2;
      }

      .cls-3, .cls-4 {
        stroke: none;
      }`}
        </style>
      </defs>
      <g id="done" transform="translate(-938 -394)">
        <g
          id="Path_16"
          data-name="Path 16"
          className="cls-1"
          transform="translate(938 394)"
        >
          <path
            className="cls-3"
            d="M22.5,0A22.5,22.5,0,1,1,0,22.5,22.5,22.5,0,0,1,22.5,0Z"
          />
          <path
            className="cls-4"
            d="M 22.5 43 C 25.26836013793945 43 27.95285987854004 42.45825958251953 30.47891044616699 41.38983154296875 C 32.9197998046875 40.357421875 35.11235809326172 38.87902069091797 36.99568939208984 36.99568939208984 C 38.87902069091797 35.11235809326172 40.357421875 32.9197998046875 41.38983154296875 30.47891044616699 C 42.45825958251953 27.95285987854004 43 25.26836013793945 43 22.5 C 43 19.73163986206055 42.45825958251953 17.04714012145996 41.38983154296875 14.52108955383301 C 40.357421875 12.0802001953125 38.87902069091797 9.887639999389648 36.99568939208984 8.00430965423584 C 35.11235809326172 6.120979785919189 32.9197998046875 4.642580032348633 30.47891044616699 3.610169887542725 C 27.95285987854004 2.541739940643311 25.26836013793945 2 22.5 2 C 19.73163986206055 2 17.04714012145996 2.541739940643311 14.52108955383301 3.610169887542725 C 12.0802001953125 4.642580032348633 9.887639999389648 6.120979785919189 8.00430965423584 8.00430965423584 C 6.120979785919189 9.887639999389648 4.642580032348633 12.0802001953125 3.610169887542725 14.52108955383301 C 2.541739940643311 17.04714012145996 2 19.73163986206055 2 22.5 C 2 25.26836013793945 2.541739940643311 27.95285987854004 3.610169887542725 30.47891044616699 C 4.642580032348633 32.9197998046875 6.120979785919189 35.11235809326172 8.00430965423584 36.99568939208984 C 9.887639999389648 38.87902069091797 12.0802001953125 40.357421875 14.52108955383301 41.38983154296875 C 17.04714012145996 42.45825958251953 19.73163986206055 43 22.5 43 M 22.5 45 C 10.07359027862549 45 -3.552713678800501e-15 34.92641067504883 -3.552713678800501e-15 22.5 C -3.552713678800501e-15 10.07359027862549 10.07359027862549 -3.552713678800501e-15 22.5 -3.552713678800501e-15 C 34.92641067504883 -3.552713678800501e-15 45 10.07359027862549 45 22.5 C 45 34.92641067504883 34.92641067504883 45 22.5 45 Z"
          />
        </g>
        <path
          id="Path_15"
          data-name="Path 15"
          className="cls-2"
          d="M4.1,7.9a.908.908,0,0,1-.7-.3L.3,4.4A.967.967,0,0,1,.3,3,.967.967,0,0,1,1.7,3L4.1,5.4,9.3.2a.967.967,0,0,1,1.4,0,.967.967,0,0,1,0,1.4l-5.9,6A.779.779,0,0,1,4.1,7.9Z"
          transform="translate(956 413.1)"
        />
      </g>
    </>
  ),
  finishedOrder: () => (
    <path
      d="M24,44C13,44,4,35,4,24C4,13,13,4,24,4c11,0,20,9,20,20C44,35,35,44,24,44z M24,6C14.1,6,6,14.1,6,24
	c0,9.9,8.1,18,18,18c9.9,0,18-8.1,18-18C42,14.1,33.9,6,24,6z M22.2,29.6l10.6-10c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0
	l-9.9,9.3l-4.7-4.8c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l5.4,5.5c0.2,0.2,0.5,0.3,0.7,0.3C21.8,29.9,22,29.8,22.2,29.6z"
    />
  ),

  filterBottomArrow: () => (
    <path d="M4,5a.908.908,0,0,1-.7-.3l-3-3A.967.967,0,0,1,.3.3.967.967,0,0,1,1.7.3L4,2.6,6.3.3A.967.967,0,0,1,7.7.3a.967.967,0,0,1,0,1.4l-3,3A.908.908,0,0,1,4,5Z" />
  ),

  backFilter: () => (
    <path
      d="M15,19c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L10.4,12l5.3,5.3
	c0.4,0.4,0.4,1,0,1.4C15.5,18.9,15.3,19,15,19z"
    />
  ),

  resetFilter: () => (
    <path
      d="M18.7,17.3c0.4,0.4,0.4,1,0,1.4C18.5,18.9,18.3,19,18,19s-0.5-0.1-0.7-0.3L12,13.4l-5.3,5.3
	C6.5,18.9,6.3,19,6,19s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l5.3-5.3L5.3,6.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5.3,5.3l5.3-5.3
	c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L13.4,12L18.7,17.3z"
    />
  ),

  home: () => (
    <path
      d="M2.2,15.8c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.7l0-8.3c0-0.2,0.1-0.4,0.2-0.6l6-5.5
	c0.3-0.3,0.7-0.3,1,0l6,5.6c0.2,0.1,0.2,0.3,0.2,0.5v8.1c0,0,0,0.1,0,0.1c-0.1,0.6-0.6,1-1.1,0.9l-3.6,0c-0.4,0-0.8-0.3-0.8-0.8
	v-3.6H6.8V15c0,0.4-0.3,0.8-0.8,0.8L2.2,15.8C2.3,15.8,2.3,15.8,2.2,15.8z M2.3,14.3C2.3,14.3,2.2,14.3,2.3,14.3L2.3,14.3
	C2.3,14.3,2.3,14.3,2.3,14.3z M2.8,6.8v7.4l2.5,0v-3.6c0-0.4,0.3-0.8,0.8-0.8h4c0.4,0,0.8,0.3,0.8,0.8v3.6h2.5l0-7.3L8,2L2.8,6.8z
	 M13.6,14.3L13.6,14.3C13.7,14.2,13.7,14.2,13.6,14.3z"
    />
  ),

  person: () => (
    <path
      d="M23,18.6v2.8c0,1-0.4,2.1-1.4,2.1h-19c-1.1,0-1.6-1.6-1.6-2.1v-2.8c0-3,2.9-5.5,7-6.5c-1.5-1.2-2.5-3-2.5-5.1
	c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5c0,2.1-1,3.9-2.5,5.1C20.1,13.1,23,15.6,23,18.6z M7.5,7c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5
	s-2-4.5-4.5-4.5S7.5,4.5,7.5,7z M21,18.6c0-2.7-4.1-5-9-5c-4.9,0-9,2.3-9,5v2.8c0,0,0,0,0,0.1H21c0,0,0-0.1,0-0.1V18.6z"
    />
  ),

  desc: () => (
    <path
      d="M11.3,8.8H2C1.6,8.8,1.3,8.4,1.3,8S1.6,7.3,2,7.3h9.3c0.4,0,0.8,0.3,0.8,0.8S11.7,8.8,11.3,8.8z M14.8,3.3
	c0-0.4-0.3-0.8-0.8-0.8H2c-0.4,0-0.8,0.3-0.8,0.8S1.6,4.1,2,4.1h12C14.4,4.1,14.8,3.7,14.8,3.3z M14.8,12.7c0-0.4-0.3-0.8-0.8-0.8H2
	c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h12C14.4,13.4,14.8,13.1,14.8,12.7z"
    />
  ),

  instructions: () => (
    <path
      d="M14,5.7c0-0.1-0.1-0.2-0.2-0.2L9.2,0.8C9.1,0.7,9,0.7,9,0.6c-0.1,0-0.2-0.1-0.3-0.1H4c-1.1,0-2.1,0.9-2.1,2.1v10.7
	c0,1.1,0.9,2.1,2.1,2.1h8c0,0,0,0,0,0c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5V6C14.1,5.9,14.1,5.8,14,5.7z M9.4,3.1l2.1,2.1
	H9.4V3.1z M12,13.9L12,13.9H4c-0.3,0-0.6-0.3-0.6-0.6V2.7c0-0.3,0.3-0.6,0.6-0.6h3.9V6c0,0.4,0.3,0.8,0.8,0.8h3.9v6.6
	C12.6,13.7,12.3,13.9,12,13.9z"
    />
  ),

  healing: () => (
    <path
      id="Path_971"
      d="M24,16l5.6-5.6c0.5-0.5,0.5-1.4,0-2c0,0,0,0,0,0l-6.1-6.1c-0.5-0.5-1.4-0.5-2,0c0,0,0,0,0,0L16,8l-5.6-5.6
	C10.1,2.1,9.8,2,9.4,2c-0.4,0-0.7,0.1-1,0.4L2.4,8.5c-0.5,0.5-0.5,1.4,0,2c0,0,0,0,0,0L7.9,16l-5.6,5.6c-0.5,0.5-0.5,1.4,0,2
	c0,0,0,0,0,0l6.1,6.1c0.5,0.5,1.4,0.5,2,0c0,0,0,0,0,0l5.6-5.6l5.6,5.6c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4l6.1-6.1
	c0.5-0.5,0.5-1.4,0-2c0,0,0,0,0,0L24,16z M16,11.8c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4l0,0
	C14.6,12.4,15.2,11.8,16,11.8z M9.4,14.5L4.3,9.5l5.1-5.1l5.1,5.1L9.4,14.5z M13.2,17.4c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4
	c0.8,0,1.4,0.6,1.4,1.4c0,0,0,0,0,0C14.6,16.8,14,17.4,13.2,17.4C13.2,17.4,13.2,17.4,13.2,17.4z M16,20.2c-0.8,0-1.4-0.6-1.4-1.4
	s0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0,0C17.4,19.6,16.8,20.2,16,20.2L16,20.2L16,20.2z M18.8,14.6c0.8,0,1.4,0.6,1.4,1.4
	c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4l0,0C17.4,15.2,18,14.6,18.8,14.6L18.8,14.6z M22.5,27.7l-5.1-5.1l5.1-5.1l5.1,5.1
	L22.5,27.7z"
    />
  ),

  star: () => (
    <path
      d="M32,12.5h-7.5l5.3-5.3l-5-5l-5.3,5.3V0h-7.1v7.5L7.2,2.2l-5,5l5.3,5.3H0v7.1h7.5l-5.3,5.3l5,5l5.3-5.3V32h7.1v-7.5l5.3,5.3
	l5-5l-5.3-5.3H32V12.5z"
    />
  ),
  category: () => (
    <path
      d="M20,22H4c-1.7,0-3-1.3-3-3V5c0-1.7,1.3-3,3-3h5c0.3,0,0.6,0.2,0.8,0.4L11.5,5H20c1.7,0,3,1.3,3,3v11C23,20.7,21.7,22,20,22z
	 M4,4C3.4,4,3,4.4,3,5v14c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8c0-0.6-0.4-1-1-1h-9c-0.3,0-0.6-0.2-0.8-0.4L8.5,4H4z"
    />
  ),

  cartLarge: () => (
    <path
      d="M21.5,44c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S21.5,42.1,21.5,44z M40,40.5c-1.9,0-3.5,1.6-3.5,3.5
	s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S41.9,40.5,40,40.5z M47.5,14.3l-3.2,16.8c-0.5,2.6-2.8,4.4-5.4,4.4c0,0-0.1,0-0.1,0H19.4
	c0,0-0.1,0-0.1,0c-2.6,0-4.9-1.8-5.4-4.4l-3.3-16.7c0,0,0-0.1,0-0.1L8.8,5.5H2C1.2,5.5,0.5,4.8,0.5,4S1.2,2.5,2,2.5h8
	c0.7,0,1.3,0.5,1.5,1.2l1.8,8.8H46c0.4,0,0.9,0.2,1.2,0.5C47.4,13.4,47.6,13.8,47.5,14.3z M44.2,15.5H13.8l3,15c0.2,1.2,1.3,2,2.5,2
	c0,0,0,0,0,0h19.5c0,0,0,0,0.1,0c1.2,0,2.2-0.8,2.5-2L44.2,15.5z"
    />
  ),
  freeDel: () => (
    <path
      d="M24,48C10.8,48,0,37.2,0,24S10.8,0,24,0s24,10.8,24,24S37.2,48,24,48z M24,3C12.4,3,3,12.4,3,24c0,11.6,9.4,21,21,21
	c11.6,0,21-9.4,21-21C45,12.4,35.6,3,24,3z M22.4,30.1l10.6-10c0.6-0.6,0.6-1.5,0.1-2.1c-0.6-0.6-1.5-0.6-2.1-0.1l-9.5,9l-4.4-4.5
	c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l5.4,5.5c0.3,0.3,0.7,0.5,1.1,0.5C21.8,30.5,22.1,30.4,22.4,30.1z"
    />
  ),
};

function SvgIcon({
  icon,
  className,
  viewBox = '0 0 24 24',
  fill,
  cursor,
  title = '',
  alt = '',
  marginLeft = 0,
  width = 24,
  height = 24,
  marginRight = 0,
  onClick = null,
  rotate,
}: Props) {
  const IconSrc: any = icons[icon];

  return (
    <IconWrapper
      cursor={cursor}
      fill={fill}
      className={className}
      viewBox={viewBox}
      onClick={onClick}
      marginLeft={marginLeft}
      marginRight={marginRight}
      width={width}
      height={height}
      rotate={rotate}
    >
      <title id="idTitle">{title}</title>
      <desc id="idDesc">{alt}</desc>
      <IconSrc />
    </IconWrapper>
  );
}

const IconStyles = css`
  vertical-align: middle;
`;

const IconWrapper = styled.svg<{
  fill?: string;
  cursor?: string;
  marginLeft: number;
  marginRight: number;
  width: number;
  height: number;
  rotate?: number;
}>`
  ${IconStyles};
  fill: ${({ theme, fill }) => (fill ? fill : theme.colors.primary)};
  cursor: ${({ cursor }) => (cursor ? cursor : 'initial')};
  transition: fill 0.2s ease, transform 0.2s ease;
  margin-left: ${props => rem(props.marginLeft)};
  margin-right: ${props => rem(props.marginRight)};
  width: ${props => rem(props.width)};
  height: ${props => rem(props.height)};
  transform: ${({ rotate }) => (rotate ? `rotate(${rotate}deg)` : 'none')};
`;

const IconPath = styled.path``;

export { SvgIcon };
